import { apiCall, API_CONFIG } from '../config/api';
import type { SearchResponse } from '../types/search';

export interface GlobalSearchParams {
  q: string;
  types?: string;
  limit?: number;
  txn_start_date?: string;
  txn_end_date?: string;
}

export async function globalSearch(params: GlobalSearchParams): Promise<SearchResponse> {
  const { q, types, limit = 5, txn_start_date, txn_end_date } = params;

  const qs = new URLSearchParams();
  qs.set('q', q);
  if (types) qs.set('types', types);
  qs.set('limit', String(limit));
  if (txn_start_date) qs.set('txn_start_date', txn_start_date);
  if (txn_end_date) qs.set('txn_end_date', txn_end_date);

  return apiCall(`${API_CONFIG.ENDPOINTS.SEARCH}?${qs.toString()}`);
}
